"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var codegen_1 = require("./codegen");
var utils_1 = require("../utils");
var Golang = /** @class */ (function (_super) {
    __extends(Golang, _super);
    function Golang() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Golang.prototype.getSafeTitle = function (title) {
        var n = _super.prototype.getSafeTitle.call(this, title);
        // Remove all non-capitalized-alpha characters before the first capitalized alpha character.
        return n.replace(/^[^A-Z]+/m, "");
    };
    Golang.prototype.generate = function (s, ir) {
        return [
            ir.documentationComment,
            [
                "type ",
                this.getSafeTitle(utils_1.getTitle(s)) + " ",
                ir.prefix ? ir.prefix + " " : "",
            ].join(""),
            ir.macros ? [ir.typing, ir.macros].join("\n") : ir.typing,
        ].join("");
    };
    Golang.prototype.handleBoolean = function (s) {
        return { typing: "bool", documentationComment: this.buildDocs(s) };
    };
    Golang.prototype.handleNull = function (s) {
        return { typing: "interface{}", documentationComment: this.buildDocs(s) };
    };
    Golang.prototype.handleNumber = function (s) {
        return { typing: "float64", documentationComment: this.buildDocs(s) };
    };
    Golang.prototype.handleInteger = function (s) {
        return { typing: "int64", documentationComment: this.buildDocs(s) };
    };
    Golang.prototype.handleNumericalEnum = function (s) {
        var safeTitle = this.getSafeTitle(s.title);
        var sEnum = s.enum;
        var enumFields = sEnum
            .filter(function (enumField) { return typeof enumField === "number"; })
            .map(function (enumField, i) { return "\t" + safeTitle + "Enum" + i + " " + safeTitle + " = " + enumField; })
            .join("\n");
        var ir = s.type === "number" ? this.handleNumber(s) : this.handleInteger(s);
        ir.typing = ir.typing + "\n" + ["const (", enumFields, ")"].join("\n");
        return ir;
    };
    Golang.prototype.handleString = function (s) {
        return { documentationComment: this.buildDocs(s), typing: "string" };
    };
    Golang.prototype.handleStringEnum = function (s) {
        var safeTitle = this.getSafeTitle(s.title);
        var sEnum = s.enum;
        var enumFields = sEnum
            .filter(function (enumField) { return typeof enumField === "string"; })
            .map(function (enumField, i) { return "\t" + safeTitle + "Enum" + i + " " + safeTitle + " = \"" + enumField + "\""; })
            .join("\n");
        var ir = this.handleString(s);
        ir.typing = ir.typing + "\n" + ["const (", enumFields, ")"].join("\n");
        return ir;
    };
    Golang.prototype.handleOrderedArray = function (s) {
        return {
            typing: "(" + this.getJoinedSafeTitles(s.items) + ")",
            documentationComment: this.buildDocs(s),
        };
    };
    Golang.prototype.handleUnorderedArray = function (s) {
        return {
            typing: "[]" + this.getSafeTitle(this.refToTitle(s.items)),
            documentationComment: this.buildDocs(s),
        };
    };
    Golang.prototype.handleUntypedArray = function (s) {
        var ir = this.handleUntyped(s);
        ir.typing = "[]" + ir.typing;
        return ir;
    };
    Golang.prototype.handleObject = function (s) {
        var _this = this;
        var sProps = s.properties;
        var propKeys = Object.keys(sProps);
        var safeTitles = propKeys.map(function (k) { return _this.getSafeTitle(k); });
        var propSchemaTitles = propKeys.map(function (k) { return _this.getSafeTitle(_this.refToTitle(sProps[k])); });
        var titleMaxLength = Math.max.apply(Math, safeTitles.map(function (t) { return t.length; }));
        var propTitleMaxLength = Math.max.apply(Math, propSchemaTitles.map(function (t) { return t.length; }));
        var propertyTypings = propKeys.reduce(function (typings, key, i) {
            var isRequired = false;
            if (s.required) {
                isRequired = s.required.indexOf(key) !== -1;
            }
            var safeTitle = safeTitles[i];
            safeTitle = safeTitle.padEnd(titleMaxLength);
            var safeTitleForPropSchema = propSchemaTitles[i];
            safeTitleForPropSchema = safeTitleForPropSchema.padEnd(propTitleMaxLength);
            return __spreadArray(__spreadArray([], typings), [
                "\t" + (safeTitle + " *" + safeTitleForPropSchema + " `json:\"" + key + (isRequired ? "" : ",omitempty") + "\"`"),
            ]);
        }, []);
        return {
            prefix: "struct",
            typing: __spreadArray(__spreadArray(["{"], propertyTypings), ["}"]).join("\n"),
            documentationComment: this.buildDocs(s),
        };
    };
    Golang.prototype.handleUntypedObject = function (s) {
        var ir = this.handleUntyped(s);
        ir.typing = "map[string]" + ir.typing;
        return ir;
    };
    Golang.prototype.unmarshalAnyOfMacro = function (typeTitle, items) {
        var components = items.map(function (itemTitle) {
            return [
                "var my" + itemTitle + " " + itemTitle,
                "if err := json.Unmarshal(bytes, &my" + itemTitle + "); err == nil {",
                "\t" + "ok = true",
                "\t" + ("a." + itemTitle + " = &my" + itemTitle),
                "}",
            ];
        });
        return [
            "func (a *" + typeTitle + ") UnmarshalJSON(bytes []byte) error {",
            "\t" + "var ok bool",
            components.map(function (c) { return c.map(function (cl) { return "\t" + cl; }).join("\n"); }).join("\n"),
            "\t" + "if ok {",
            "\t\t" + "return nil",
            "\t" + "}",
            "\t" + "return errors.New(\"failed to unmarshal any of the object properties\")",
            "}",
        ].join("\n");
    };
    Golang.prototype.marshalAnyOfMacro = function (typeTitle, items) {
        var components = items.map(function (itemTitle) {
            return [
                "if o." + itemTitle + " != nil {",
                "\t" + ("out = append(out, o." + itemTitle + ")"),
                "}",
            ];
        });
        return [
            "func (o " + typeTitle + ") MarshalJSON() ([]byte, error) {",
            "\t" + "out := []interface{}{}",
            components.map(function (c) { return c.map(function (cl) { return "\t" + cl; }).join("\n"); }).join("\n"),
            "\t" + "return json.Marshal(out)",
            "}",
        ].join("\n");
    };
    Golang.prototype.unmarshalOneOfMacro = function (typeTitle, items) {
        var components = items.map(function (itemTitle) {
            return [
                "var my" + itemTitle + " " + itemTitle,
                "if err := json.Unmarshal(bytes, &my" + itemTitle + "); err == nil {",
                "\t" + ("o." + itemTitle + " = &my" + itemTitle),
                "\t" + "return nil",
                "}",
            ];
        });
        var comment = [
            "// UnmarshalJSON implements the json Unmarshaler interface.",
            "// This implementation DOES NOT assert that ONE AND ONLY ONE",
            "// of the simple properties is satisfied; it lazily uses the first one that is satisfied.",
            "// Ergo, it will not return an error if more than one property is valid.",
        ].join("\n");
        return [
            comment,
            "func (o *" + typeTitle + ") UnmarshalJSON(bytes []byte) error {",
            components.map(function (c) { return c.map(function (cl) { return "\t" + cl; }).join("\n"); }).join("\n"),
            "\t" + "return errors.New(\"failed to unmarshal one of the object properties\")",
            "}",
        ].join("\n");
    };
    Golang.prototype.marshalOneOfMacro = function (typeTitle, items) {
        var components = items.map(function (itemTitle) {
            return [
                "if o." + itemTitle + " != nil {",
                "\t" + ("return json.Marshal(o." + itemTitle + ")"),
                "}",
            ];
        });
        return [
            "func (o " + typeTitle + ") MarshalJSON() ([]byte, error) {",
            components.map(function (c) { return c.map(function (cl) { return "\t" + cl; }).join("\n"); }).join("\n"),
            "\t" + "return nil, errors.New(\"failed to marshal any one of the object properties\")",
            "}",
        ].join("\n");
    };
    Golang.prototype.handleAnyOf = function (s) {
        var _this = this;
        var sAny = s.anyOf;
        var titles = sAny.map(function (ss) { return _this.getSafeTitle(_this.refToTitle(ss)); });
        var titleMaxLength = Math.max.apply(Math, titles.map(function (t) { return t.length; }));
        var anyOfType = titles.reduce(function (typings, anyOfTitle) {
            return __spreadArray(__spreadArray([], typings), ["\t" + anyOfTitle.padEnd(titleMaxLength) + " *" + anyOfTitle]); // Here, the pointer is added.
        }, []);
        var title = this.getSafeTitle(s.title);
        return {
            macros: [
                this.unmarshalAnyOfMacro(title, titles),
                this.marshalAnyOfMacro(title, titles),
            ].join("\n"),
            prefix: "struct",
            typing: __spreadArray(__spreadArray(["{"], anyOfType), ["}"]).join("\n"),
            documentationComment: this.buildDocs(s),
            imports: [
                "import \"encoding/json\"",
                "import \"errors\""
            ]
        };
    };
    /**
     * must be a set of schemas with type: object
     */
    Golang.prototype.handleAllOf = function (s) {
        this.warnNotWellSupported("allOf");
        return this.handleUntypedObject(s);
    };
    Golang.prototype.handleOneOf = function (s) {
        var _this = this;
        var sOne = s.oneOf;
        var titles = sOne.map(function (ss) { return _this.getSafeTitle(_this.refToTitle(ss)); });
        var titleMaxLength = Math.max.apply(Math, titles.map(function (t) { return t.length; }));
        var oneOfType = sOne.reduce(function (typings, oneOfSchema, i) {
            var oneOfTitle = titles[i];
            return __spreadArray(__spreadArray([], typings), [
                "\t" + [
                    oneOfTitle.padEnd(titleMaxLength),
                    "*" + oneOfTitle,
                ].join(" "),
            ]);
        }, []);
        var title = this.getSafeTitle(s.title);
        return {
            macros: [
                this.unmarshalOneOfMacro(title, titles),
                this.marshalOneOfMacro(title, titles),
            ].join("\n"),
            prefix: "struct",
            typing: __spreadArray(__spreadArray(["{"], oneOfType), ["}"]).join("\n"),
            documentationComment: this.buildDocs(s),
            imports: [
                "import \"encoding/json\"",
                "import \"errors\""
            ]
        };
    };
    Golang.prototype.handleConstantBool = function (s) {
        return {
            typing: "type Always" + (s === true ? "True" : "False") + " interface{}",
        };
    };
    Golang.prototype.handleUntyped = function (s) {
        return { documentationComment: this.buildDocs(s), prefix: "", typing: "interface{}" };
    };
    Golang.prototype.buildDocs = function (s) {
        var docStringLines = [];
        if (s.description) {
            docStringLines.push("// " + s.description);
        }
        if (s.default) {
            var def = s.default;
            var defAsStr = "" + def;
            if (def instanceof Array || (typeof def === "object" && def !== null)) {
                defAsStr = JSON.stringify(def);
            }
            docStringLines.push("//");
            docStringLines.push("// --- Default ---");
            docStringLines.push("//");
            docStringLines.push("// " + defAsStr);
        }
        if (s.examples) {
            s.examples.forEach(function (example) {
                docStringLines.push("//");
                docStringLines.push("// --- Example ---");
                docStringLines.push("//");
                docStringLines.push("// `" + example + "`");
            });
        }
        if (docStringLines.length > 0) {
            docStringLines.push("");
            return docStringLines.join("\n");
        }
    };
    Golang.prototype.warnNotWellSupported = function (typing) {
        console.warn("In Golang, " + typing + " is not well supported.");
    };
    return Golang;
}(codegen_1.CodeGen));
exports.default = Golang;
